import { Modal } from "antd";
import { pipViewDate } from "../../../../utils/pip";

const WebinarDetails = ({ isModal, setIsModal, data }) => {
  return (
    <Modal
      className=""
      visible={isModal}
      onCancel={() => {
        
        setIsModal(false);
      }}
      centered={true}
      footer={null}
    >
    <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              
              <div class="modal-body px-4 pb-5">
                <div>
                  <h4 class="mb-1 ct_fs_20">Webinar Details</h4>
                  <p class="mb-0 ct_grey_text">
                    See full details for this newly registered user
                  </p>
                </div>

                <ul className="ct_webinar_grid_2 mt-4">
                  <li>
                    <p className="mb-0 ct_fs_14">Title </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">
                      {data?.first_name ?? ""} {data?.last_name ?? ""}
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 ct_fs_14">Email </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">
                      {data?.email ?? ""}
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 ct_fs_14">Join Date </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">{pipViewDate(data?.created_at) ?? ""}</p>
                  </li>
                  <li>
                    <p className="mb-0 ct_fs_14">Phone Number </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">
                      {data?.phone_number ?? ""}
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 ct_fs_14">Role </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">{data?.role ?? ""}</p>
                  </li>
                  <li>
                    <p className="mb-0 ct_fs_14">Source </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">{data?.source ?? ""}</p>
                  </li>
                  <li>
                    <p className="mb-0 ct_fs_14">Role </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">{data?.role ?? ""}</p>
                  </li>
                  <li>
                    <p className="mb-0 ct_fs_14">Linkedin Url </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">{data?.linkedin_url ?? ""}</p>
                  </li>
                
                </ul>
              </div>
            </div>
          </div>
    </Modal>
   
  );
};

export default WebinarDetails;
